/* FANNUR v0.5: safely replace an edited cart design after the new upload succeeds. */
(function(){
 'use strict';
 if(window.__fannurCartEditorInstalled)return;
 window.__fannurCartEditorInstalled=true;
 const root=window.Shopify?.routes?.root||'/';
 async function reconcile(){
   let pending;
   try{pending=JSON.parse(sessionStorage.getItem('fannur_pending_edit')||'null');}catch{sessionStorage.removeItem('fannur_pending_edit');return;}
   if(!pending||!pending.oldDesignId||!pending.newDesignId)return;
   if(Date.now()-pending.created>24*3600*1000){sessionStorage.removeItem('fannur_pending_edit');return;}
   try{
     const resp=await fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
     if(!resp.ok)return;
     const cart=await resp.json();
     const oldItem=cart.items.find(i=>i.properties?.['Ontwerpnummer']===pending.oldDesignId);
     const newItem=cart.items.find(i=>i.properties?.['Ontwerpnummer']===pending.newDesignId);
     if(!newItem)return; // Never delete old item until replacement successfully entered cart.
     if(!oldItem){sessionStorage.removeItem('fannur_pending_edit');return;}
     const change=await fetch(root+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:oldItem.key,quantity:0})});
     if(!change.ok)throw Error('Het oude ontwerp kon niet worden vervangen.');
     sessionStorage.removeItem('fannur_pending_edit');
     window.location.replace(root+'cart');
   }catch(err){console.warn('[FANNUR] Bijwerken van de winkelwagen is niet afgerond.',err);}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',reconcile,{once:true});else reconcile();
})();